import { AiAssetReviewStatus } from "@/store/ai-asset-review/ai-asset-review-slice";
import { Stack } from "@mui/material";
import { memo, type JSX } from "react";
import { AiAssetReviewStatusChip } from "./ai-asset-review-status-chip";

type AiAnnotationStatusDisplayProps = {
  /** The review status of the annotation */
  status: AiAssetReviewStatus;
};

/** @returns status display with icon and badge for approved/rejected annotations */
export const AiAnnotationStatusDisplay = memo(
  function AiAnnotationStatusDisplay({
    status,
  }: AiAnnotationStatusDisplayProps): JSX.Element {
    const isApproved = status === AiAssetReviewStatus.approved;

    return (
      <Stack
        direction="row"
        spacing={1}
        sx={{ justifyContent: "center", alignItems: "center" }}
      >
        <AiAssetReviewStatusChip
          label={isApproved ? "Approved" : "Rejected"}
          variant={isApproved ? "approved" : "rejected"}
        />
      </Stack>
    );
  },
);
